module.exports = __webpack_public_path__ + "img/dan5.a5e9997a.png";